export const TABLE_NAME_JA = {
  organizationName: '団体名',
  userId: 'ユーザーID',
  userName: '氏名',
  phoneNumber: '電話番号',
  createAt: '登録日時',
  lastLoginAt: '最終ログイン日時',
  deleteCheckbox: '削除'
} as const

export const FIELDS_TYPED = Object.entries(TABLE_NAME_JA).map(([key, label]) => {
  return { key: key, label: label }
})
